import { getStaticNewsProps, getStaticNewsTypePaths } from '@dreamstack/feature-components/src/news/NewsHub'
import { NewsHubWithSearch } from '@dreamstack/feature-components/src/news/NewsHubWithSearch'
import { NEWS_TYPES_WEB } from '@dreamstack/feature-components/src/news/newsTypeUrls.static'
import { getStaticPathsPlus } from '../../../lib/getStaticPathsPlus'
import { getStaticPropsPlus } from '../../../lib/getStaticPropsPlus'

export default function NewsHubPage() {
  return <NewsHubWithSearch showSubhero={false} newsTypes={NEWS_TYPES_WEB} />
}

export const getStaticProps = getStaticPropsPlus({
  getProps: getStaticNewsProps,
})

export const getStaticPaths = getStaticPathsPlus({
  fallback: false,
  localizePaths: false,
  getPaths: async () => {
    return getStaticNewsTypePaths(NEWS_TYPES_WEB)
  },
})
